import { useState, useEffect } from 'react';
import { useSession } from 'next-auth/react';

export const usePmsId = () => {
  const { data: session } = useSession();
  const [pmsId, setPmsId] = useState<string | null>(null);
  const [isLoadingPms, setIsLoadingPms] = useState(true);

  useEffect(() => {
    const fetchPmsId = async () => {
      try {
        setIsLoadingPms(true);
        const response = await fetch('/api/practitioner-setup/sync-pms', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();
          setPmsId(data.pmsId);
        } else {
          setPmsId(null);
        }
      } catch (error) {
        console.error('Error fetching PMS ID:', error);
        setPmsId(null);
      } finally {
        setIsLoadingPms(false);
      }
    };

    if (session?.user?.id) {
      fetchPmsId();
    } else {
      setIsLoadingPms(false);
    }
  }, [session?.user?.id]);

  return {
    pmsId,
    setPmsId,
    isLoadingPms,
  };
};

